import {
  ChangeDetectorRef,
  Component,
  inject, input,
  InputSignal,
} from '@angular/core';
import {IonButton, IonCard, IonCardContent, IonIcon, ToastController} from '@ionic/angular/standalone';
import {PropertyService} from '../../property.service';
import {CurrencyPipe} from '@angular/common';
import {whatsAppNumberFloating} from '../../../configs/content/contact-details-en';
import {CurrencyConvertService} from '../../../core/currency.convert.service';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-price-card',
  template: `
    <ion-card>
      <ion-card-content>
        <div class="price">
          <small>{{ 'price_card.rent_for' | translate }}</small>
          @if (property()?.priceRange?.min) {
            <span>{{ property()?.priceRange.min | currency: currencyConvertService.localCurrency() + ' ' }} - {{ property()?.priceRange.max | currency: currencyConvertService.localCurrency() + ' ' }}</span> <strong>{{ property()?.priceGroup }}</strong>

          } @else {
            <span>{{ property()?.newPrice | currency: currencyConvertService.localCurrency() + ' ' }}</span> <strong>{{ property()?.priceGroup }}</strong>
          }
        </div>
        <ion-button expand="block" (click)="propertyService.openEnquireModal(property())">{{ 'price_card.book_now' | translate }}</ion-button>
        @if (property()?.virtualTour) {
          <ion-button expand="block" [href]="property()?.virtualTour" target="_blank" fill="outline">{{ 'price_card.virtual_tour' | translate }}</ion-button>
        }
        <div class="divider-with-text"><span>{{ 'price_card.reach_support' | translate }}</span></div>
        <div class="buttons-wrapper">
          <ion-button color="dark" fill="outline" (click)="phoneClickedChange(whatsAppNumberFloating)"
                      [href]="phoneClicked ? 'tel:' + whatsAppNumberFloating : null"
                      target="_blank"
                      [class.disabled]="!phoneClicked"><ion-icon name="call-outline"></ion-icon>
            {{ phoneClicked ? whatsAppNumberFloating : ('price_card.phone_call' | translate) }}</ion-button>
          <ion-button color="dark" fill="outline"
                      target="_blank"
                      [href]="'https://wa.me/' + whatsAppNumberFloating"><ion-icon name="logo-whatsapp"></ion-icon> {{ 'property.whatsapp' | translate }}</ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  `,
  styles: `
    .disabled {
      color: gray;
      cursor: not-allowed;
    }
    ion-card {
      margin: 0;
      box-shadow: none;
      border: 1px var(--border-color-gray) solid;
      background: transparent;
      color: var(--ion-text-color);
      .price {
        margin-bottom: 1rem;
        font-size: 1.5rem;
        strong {
          text-transform: capitalize;
          font-weight: normal;
          font-size: 1rem;
          display: inline-block;
          margin-inline-start: 8px;
        }
        small {
          display: block;
        }
        span {
          font-weight: 600;
        }
      }
    }
    ion-button {
      &[expand="block"] {
        margin-bottom: 10px;
      }
      ion-icon {
        margin-inline-end: 6px;
        font-size: .9rem;
      }
    }
    .buttons-wrapper {
      display: flex;
      gap: 8px;
      ion-button {
        flex: 1;
      }
    }
  `,
  imports: [
    IonCard,
    IonCardContent,
    IonButton,
    CurrencyPipe,
    IonIcon,
    TranslateModule
  ]
})
export class PriceCardComponent {

  property: InputSignal<any> = input();
  propertyService: PropertyService = inject(PropertyService);
  currencyConvertService: CurrencyConvertService = inject(CurrencyConvertService);
  cds: ChangeDetectorRef = inject(ChangeDetectorRef);
  phoneClicked: boolean = false;
  constructor(private toastController: ToastController) {
  }

  phoneClickedChange(phoneNumber: string) {
    this.phoneClicked = true;
    navigator.clipboard.writeText(phoneNumber);
    this.showToast();
  }

  async showToast() {
    const toast = await this.toastController.create({
      message: 'Phone number copied!',
      duration: 3000,
      mode: 'md',
      position: 'bottom',
    });
    await toast.present();
  }
  protected readonly whatsAppNumberFloating = whatsAppNumberFloating;
}
